module.exports = __webpack_public_path__ + "static/img/10.87b8235.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/5/eng/10.png
// module id = vg2H
// module chunks = 0